// NOTE: no ENV vars should be referenced here beyond NODE_ENV or other things which are known at image build time and which never vary based on the deployment environment.
const { NODE_ENV } = process.env;

export const isProductionBuild = NODE_ENV === "production";
